import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

import {
    DEFAULT_INSIGHTS_WINDOW,
    INSIGHTS_WINDOW_SCHEMA,
} from '@apps/web/components/metrics/insights/insights_window_picker';
import { MetricsPage } from '@apps/web/components/metrics/metrics_page';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import {
    useOrganization,
    useUser,
} from '@apps/web/swr_data_fetching/data_fetching_hooks';

export const Route = createFileRoute('/_app/(main)/metrics')({
    component: MetricsRoute,
    head: () => ({
        meta: [
            {
                title: 'Metrics | Phoebe',
            },
        ],
    }),
    validateSearch: z.object({
        insights_window: INSIGHTS_WINDOW_SCHEMA.optional().catch(
            DEFAULT_INSIGHTS_WINDOW,
        ),
    }),
});

function MetricsRoute() {
    const organizationId = useOrganizationId();
    const { data: user } = useUser({ reason: 'metrics-route-guard' });
    const { data: organization } = useOrganization(organizationId, {
        reason: 'metrics-route-guard',
    });
    const navigate = useNavigate();

    useEffect(() => {
        if (
            user &&
            organization &&
            !user.admin &&
            !organization.features?.['metrics_enabled']
        ) {
            navigate({ to: '/', replace: true });
        }
    }, [user, organization, navigate]);

    if (
        user &&
        organization &&
        !user.admin &&
        !organization.features?.['metrics_enabled']
    ) {
        return null;
    }

    return <MetricsPage />;
}
